import { render, staticRenderFns } from "./staffshujuDetail.vue?vue&type=template&id=0798e130&scoped=true&"
import script from "./staffshujuDetail.vue?vue&type=script&lang=js&"
export * from "./staffshujuDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffshujuDetail.vue?vue&type=style&index=0&id=0798e130&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0798e130",
  null
  
)

export default component.exports